import { RequestStatus } from 'features/request/requestSlice';
import { useRequest } from 'features/request/useRequest';
import { getCheckedIdsArr } from 'utils';
import { ExportCSVReport } from 'utils/createCSVReportFile';

import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { addRatioToContractChange } from '../AgreementsQueries';

const TITLE_ADD_RATIO_ERROR = 'Отображение списка коэффициентов';

export const useAddRatioAgreements = (
    agreementId: number,
    checkedIds: Record<string, boolean>,
    setCheckedIds: (value: Record<string, boolean>) => void,
    refreshAgreementRatio: () => void,
    setOpenModal: (value: boolean) => void,
    refreshFilters: () => void,
) => {
    const dispatch = useDispatch();

    const [isSubmittedAddRatio, setIsSubmittedAddRatio] = useState<boolean>(false);

    const [addRatioAgreementsData, addRatioAgreementsStatus, addRatioAgreementsError, addRatioAgreementsRequest] =
        useRequest({
            requestId: 'addRatioToContractChange',
            query: addRatioToContractChange,
            withEffect: false,
        });

    useEffect(() => {
        if (
            isSubmittedAddRatio &&
            addRatioAgreementsStatus === RequestStatus.SUCCESS &&
            addRatioAgreementsData?.uerAddRatiosToContractChange?.result
        ) {
            refreshAgreementRatio();
            refreshFilters();
            setIsSubmittedAddRatio(false);
            setOpenModal(false);
            setCheckedIds({});
        }
    }, [
        addRatioAgreementsData?.uerAddRatiosToContractChange?.result,
        addRatioAgreementsStatus,
        isSubmittedAddRatio,
        refreshAgreementRatio,
        refreshFilters,
        setCheckedIds,
        setOpenModal,
    ]);

    const handleAddRatioAgreements = useCallback(() => {
        const ratioRowIds = getCheckedIdsArr(checkedIds);

        dispatch(
            addRatioAgreementsRequest({
                contractChangeId: agreementId,
                ratioRowIds,
            }),
        );

        setIsSubmittedAddRatio(true);
    }, [addRatioAgreementsRequest, agreementId, checkedIds, dispatch]);

    const handleCloseErrorModalAddRatio = useCallback(() => {
        setIsSubmittedAddRatio(false);
    }, []);

    const handleCreateReportAddRatio = () => {
        ExportCSVReport(addRatioAgreementsData?.uerAddRatiosToContractChange?.validation);
    };

    return {
        titleAddError: TITLE_ADD_RATIO_ERROR,
        addRatioAgreementsData: addRatioAgreementsData?.uerAddRatiosToContractChange,
        addRatioAgreementsStatus,
        addRatioAgreementsError,
        isSubmittedAddRatio,
        handleAddRatioAgreements,
        handleCloseErrorModalAddRatio,
        handleCreateReportAddRatio,
    };
};
